import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"
import { MajorOccupation, MinorOccupation } from "~/api/_common/types-for-occupations"

import { CompanyForNewGradJobDetail } from "../_types"

const getPath = (id: number) => `/new-grad-jobs/${id}`

export type GetNewGradJobsByIdQuery = {
  id: number
  limitedUrlToken?: string | string[]
}

export type GetNewGradJobsById = { errorCode: 404 } | NewGradJobDetail

export const fetchGetNewGradJobsById = defineFetcher(
  (idAndQuery: GetNewGradJobsByIdQuery): Promise<GetNewGradJobsById> => {
    const { id, ...query } = idAndQuery
    return GET(getPath(id), query)
  }
)

export interface NewGradJobDetail {
  id: number
  title: string
  assumed_annual_income: number
  mission: string
  services: string
  job_description: string
  career_path: string
  qualification: string
  salary: string
  employee_benefits: string
  work_pattern: string
  location: string
  entry_period: string
  enter_period: string
  selection_flow: string
  needs_external_entry: boolean
  entry_url: string
  public: boolean
  images: { img_url: string }[]
  company: CompanyForNewGradJobDetail
  major_occupation: MajorOccupation
  minor_occupation: MinorOccupation
  regions: string[]
  target_grad_years: number[]
  salaries: { year: number; amount: number }[]
  work_schedules: WorkSchedule[]
  careers: Career[]
}

interface WorkSchedule {
  time: string
  title: string
  description: string
  img_url?: string
}

interface Career {
  title: string
  description: string
  steps: { title: string; enrollment_period: string }[]
}
